import { helper } from '@ember/component/helper';

import { colorForCategory } from '../utils/style-utils';

export function categoryColor([status]: [string | undefined]) {
  return colorForCategory(status);
}
const categoryColorHelper = helper(categoryColor);
export default categoryColorHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'category-color': typeof categoryColorHelper;
  }
}
